import _Reader from './model';
import * as _actions from './actions';
import _reducer from './reducer';

_Reader.actions = _actions;

export const Reader = _Reader;
export const actions = _actions;
export const reducer = _reducer;



// WEBPACK FOOTER //
// ./data/Reader/index.js